// TerritoryQuickCreateModal.js
import React, { useState, useEffect } from "react";
import {
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
} from "@mui/material";

import CrmDialog from "../components/CrmDialog";
import ModalHeader from "../components/ModalHeader";

import API from "../utils/api";
import { toast } from "react-toastify";

export default function TerritoryQuickCreateModal({ open, onClose, onCreated, isReadOnly = false }) {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({
    name: "",
    manager: "",
    reps: [],
    lead_count: "",
  });

const resetForm = () =>
  setForm({
    name: "",
    manager: "",
    reps: [],
    lead_count: "",
  });
const handleCancel = () => {
  resetForm();
  onClose();
};



  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await API.get("/users/");
        setUsers(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchUsers();
  }, []);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleCreate = async () => {
    if (!form.name || !form.manager) {
      toast.error("Please fill all required fields.");
      return;
    }


    try {
      await API.post("/territories/", {
        name: form.name,
        manager: form.manager,
        assigned_reps: form.reps,
        lead_count: form.lead_count || 0,
      });

      toast.success("Territory created!");
      onCreated();
      onClose();
      setForm({ name: "", manager: "", reps: [], lead_count: "" });
    } catch (err) {
      toast.error("Failed to create territory.");
      console.error(err);
    }
  };

  return (
    <CrmDialog open={open} onClose={onClose} maxWidth="sm" fullWidth>

      {/* 🌟 SmartTable-Styled Modal Header */}
      <ModalHeader
        title="Create New Territory"
        subtitle="Quickly create and assign a territory to managers and reps."
      />

      <DialogContent sx={{ mt: 1 }}>
        <Box display="flex" flexDirection="column" gap={2}>

          <TextField
            fullWidth
            label="Territory Name"
            value={form.name}
            onChange={(e) => handleChange("name", e.target.value)}
            disabled={isReadOnly}
          />

         <TextField
  select
  fullWidth
  label="Manager"
  value={form.manager}
  onChange={(e) => handleChange("manager", e.target.value)}
  InputLabelProps={{ shrink: true }}
  disabled={isReadOnly}
>
  {users.map((u) => (
    <MenuItem key={u.id} value={u.id}>
      {u.first_name} {u.last_name}
    </MenuItem>
  ))}
</TextField>


          <Autocomplete
            multiple
            fullWidth
            options={users}
            getOptionLabel={(u) => `${u.first_name} ${u.last_name}`}
            value={users.filter((u) => form.reps.includes(u.id))}
            onChange={(e, newVal) =>
              handleChange(
                "reps",
                newVal.map((r) => r.id)
              )
            }
            disabled={isReadOnly}
            renderInput={(params) => (
              <TextField {...params} label="Assigned Reps" InputLabelProps={{ shrink: true }} />
            )}
          />

        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button variant="outlined" onClick={handleCancel}>
  Cancel
</Button>

        <Button variant="contained" onClick={handleCreate} disabled={isReadOnly}>
          Create Territory
        </Button>
      </DialogActions>
    </CrmDialog>
  );
}
